import React from 'react'
import ReactPlayer from 'react-player/vimeo'
import {FaPlay} from 'react-icons/fa'
import {Link, useLocation, useNavigate} from 'react-router-dom'

function Tab4({values, handleChange, setFieldValue}) {
  const navigate = useNavigate()
  let imageURL = ''
  if (values.isEdit) {
    if (values.bannerImage) {
      imageURL = values.bannerImage ? URL.createObjectURL(values.bannerImage) : ''
    } else {
      imageURL = values.imgUrl
    }
  } else {
    imageURL = values.bannerImage ? URL.createObjectURL(values.bannerImage) : ''
  }

  return (
    <div className='pt-4 px-4 mb-3' style={{fontSize: '14px'}}>
      <div className='d-flex align-items-start gap-3'>
        {values.bannerImage || values.imgUrl ? (
          <img
            style={{cursor: 'pointer', width: '400px', height: '200px', objectFit: 'cover'}}
            src={imageURL}
            alt=''
          ></img>
        ) : (
          <img style={{width: '400px'}} src='https://placehold.co/400x200?text= No Image' />
        )}
        <div className='d-flex flex-column t-14 gap-2 mt-2'>
          <div className='d-flex gap-1'>
            <div className='fw-bold m-0'>Code:</div>
            <div>{values?.code}</div>
          </div>
          <div className='d-flex gap-1'>
            <div className='fw-bold m-0'>Unit Name:</div>
            <div>{values.unitName}</div>
          </div>
          <div className='d-flex gap-1'>
            <div className='fw-bold m-0'>Cohort:</div>
            <div>{values.cohort}</div>
          </div>
          <div className='d-flex gap-1'>
            <div className='fw-bold m-0'>Tags:</div>
            <div>
              {values.tags.map((val, index) =>
                values.tags.length - 1 === index ? val : val + ', '
              )}
            </div>
          </div>
          <div className='d-flex gap-1'>
            <div className='fw-bold m-0'>Language:</div>
            <div>{values.language}</div>
          </div>
        </div>
      </div>
      <div className='mt-3'>
        <div className='fw-bold mt-8'>Description</div>
        <div className='mt-2'>{values.shortDescription}</div>
      </div>
      <hr className='hr-3 my-8' />
      <div className='w-100'>
        <div className='mt-3 d-flex justify-content-start align-items-start gap-10 flex-wrap'>
          {values?.videos &&
            values?.videos?.map((val, index) => (
              <div
                className='shadow-lg  overflow-hidden bg-white text-black'
                key={index}
                style={{width: '220px', borderRadius: '9px'}}
              >
                <div className='player-wrapper position-relative'>
                  <ReactPlayer
                    className='react-player'
                    width='100%'
                    height='160px'
                    url={val?.link}
                  />
                  <div
                    className='icon-overlay position-absolute'
                    style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}}
                  >
                    <FaPlay size={50} color='black' />
                  </div>
                </div>

                <hr className='hr' />
                <div className='px-2 ' style={{height: '90px'}}>
                  <div className='fw-bold fs-7'>
                    {' '}
                    {val?.title?.length > 28 ? val?.title.slice(0, 28) + ' ....' : val?.title}
                  </div>
                  <div className='mb-3 text-start fs-8 fw-light mt-2'>
                    {val?.description?.length > 90
                      ? val?.description.slice(0, 90) + ' ....'
                      : val?.description}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default Tab4
